import builder from '../builder';
import CheckCircle1 from '../../streamline-icons/light/check-circle-1.svg';

export default builder('IconCheckCircle1Light', CheckCircle1);
